import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IRecipeBlockItem } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class RecipeBlockItemService extends BaseService<IRecipeBlockItem> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'recipeBlockItem');
  }
}

export { IRecipeBlockItem } from '../shared/api';
